export default {
	SET_USER (context, payload) {
		context.commit("SET_USER", payload);
	},
	SET_AUTHORIZED (context, payload) {
		context.commit("SET_AUTHORIZED", payload);
	},
	SET_ADMINISTRATOR (context, payload) {
		context.commit("SET_ADMINISTRATOR", payload);
	},
	SET_TOKEN (context, payload) {
		context.commit("SET_TOKEN", payload);
	},
	SET_SELECTED_PERSON_KEY (context, payload) {
		context.commit("SET_SELECTED_PERSON_KEY", payload);
	},
	SET_SELECTED_PERSON_VEHICLES (context, payload) {
		context.commit("SET_SELECTED_PERSON_VEHICLES", payload);
	},
	SET_SELECTED_PERSON_IS_USER (context, payload) {
		context.commit("SET_SELECTED_PERSON_IS_USER", payload);
	},
	SET_PEOPLE (context, payload) {
		context.commit("SET_PEOPLE", payload);
	},
	SET_TECHNOLOGY (context, payload) {
		context.commit("SET_TECHNOLOGY", payload);
	},
	SET_SKILLS_RATING_BY_TECHNOLOGY (context, payload) {
		context.commit("SET_SKILLS_RATING_BY_TECHNOLOGY", payload);
	},
	SET_SKILLS_RATING_BY_PERSON (context, payload){
		context.commit("SET_SKILLS_RATING_BY_PERSON", payload);
	},
	SET_SELECTED_PERSON_SKILLS_RATING (context, payload){
		context.commit("SET_SELECTED_PERSON_SKILLS_RATING", payload);
	},
	SET_PERSON (context, payload) {
		context.commit("SET_PERSON", payload);
	},
	SET_GROUPS (context, payload) {
		context.commit("SET_GROUPS", payload);
	},
	SET_SELECTED_GROUP_KEY (context, payload) {
		context.commit("SET_SELECTED_GROUP_KEY", payload);
	},
	SET_SELECTED_GROUP (context, payload) {
		context.commit("SET_SELECTED_GROUP", payload);
	},
	SET_MEMBERSHIPS (context, payload) {
		context.commit("SET_MEMBERSHIPS", payload);
	},
	SET_SELECTED_GROUP_MEMBERS (context, payload) {
		context.commit("SET_SELECTED_GROUP_MEMBERS", payload);
	},
	SET_SELECTED_MEMBER_KEY (context, payload) {
		context.commit("SET_SELECTED_MEMBER_KEY", payload);
	},
	SET_SELECTED_MEMBER (context, payload) {
		context.commit("SET_SELECTED_MEMBER", payload);
	},
	SET_SELECTED_MEMBERSHIPS (context, payload) {
		context.commit("SET_SELECTED_MEMBERSHIPS", payload);
	},
	SET_SELECTED_SLACK_MEMBER (context, payload) {
		context.commit("SET_SELECTED_SLACK_MEMBER", payload);
	},
	SET_SELECTED_SLACK_MEMBERSHIPS (context, payload) {
		context.commit("SET_SELECTED_SLACK_MEMBERSHIPS", payload);
	},
	SET_BIRTHDAYS_THIS_MONTH (context, payload) {
		context.commit("SET_BIRTHDAYS_THIS_MONTH", payload);
	},
	SET_ANNIVERSARIES_THIS_MONTH(context, payload){
		context.commit("SET_ANNIVERSARIES_THIS_MONTH", payload);
	},
	SET_TOGGL_PROJECTS (context, payload) {
		context.commit("SET_TOGGL_PROJECTS", payload);
	},
	SET_PROJECTS_MANAGEMENT_OVERVIEW (context, payload) {
		context.commit("SET_PROJECTS_MANAGEMENT_OVERVIEW", payload);
	},
	SET_PROJECTS_MANAGEMENT_DETAILS (context, payload) {
		context.commit("SET_PROJECTS_MANAGEMENT_DETAILS", payload);
	},
	SET_SELECTED_PROJECT_KEY (context, payload) {
		context.commit("SET_SELECTED_PROJECT_KEY", payload);
	},
	SET_PROJECT (context, payload) {
		context.commit("SET_PROJECT", payload);
	},
};



// WEBPACK FOOTER //
// ./src/store/actions.js